import type { OperationalObligation } from "@io-spoke/contracts/obligations";
import { obligationOwnership } from "../../lib/obligationOwnership";

export function ObligationOwnership({ obligation }: { obligation: OperationalObligation }) {
  const ownership = obligationOwnership(obligation);
  return (
    <div className="min-w-0">
      <p className="text-xs text-muted-foreground">{ownership.label}</p>
      <p className="mt-1 break-words text-sm font-medium">{ownership.reference}</p>
      <p className="mt-1 text-xs leading-5 text-muted-foreground">{ownership.explanation}</p>
    </div>
  );
}
